import { render, staticRenderFns } from "./distributortags.vue?vue&type=template&id=05761659&scoped=true"
import script from "./distributortags.vue?vue&type=script&lang=js"
export * from "./distributortags.vue?vue&type=script&lang=js"
import style0 from "./distributortags.vue?vue&type=style&index=0&id=05761659&prod&scoped=true&lang=scss"
import style1 from "./distributortags.vue?vue&type=style&index=1&id=05761659&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05761659",
  null
  
)

export default component.exports